export default "__VITE_ASSET__DN$o4fE6__"